import { render, staticRenderFns } from "./DashbordForm.vue?vue&type=template&id=6fbdbc1c&"
import script from "./DashbordForm.vue?vue&type=script&lang=js&"
export * from "./DashbordForm.vue?vue&type=script&lang=js&"
import style0 from "./DashbordForm.vue?vue&type=style&index=0&id=6fbdbc1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports